module.exports = __webpack_public_path__ + "img/check-green.e74f0ab5.svg";